var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "take-a-stand--template page-template bg-beige pb5" },
          [
            _c(
              "div",
              { staticClass: "db relative pt4 pb5 pt5-ns pb6-ns z-content" },
              [
                _c(
                  "div",
                  { staticClass: "relative container-fluid mw9 center" },
                  [
                    _c("section", { staticClass: "relative mw8 center" }, [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "mv0 ttu f-page-title-take is-blenny is-navy mt4 mt0-m mt0-l is-navy",
                        },
                        [_vm._v(_vm._s(_vm.page.title))]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.page.intro_section &&
                    _vm.page.intro_section.is_published
                      ? _c(
                          "section",
                          {
                            staticClass: "db relative center mw8",
                            attrs: { id: _vm.page.intro_section.id },
                          },
                          [
                            _vm.page.intro_section.header
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "mt5 tc ttu f2 is-lorano-bold is-green",
                                  },
                                  [_vm._v(_vm._s(_vm.page.intro_section.title))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "relative mt4 f3 lh-copy tl is-tablet-semicond-bold is-navy cms-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.marked(_vm.page.intro_section.text)
                                ),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.page.act_section && _vm.page.act_section.is_published
                      ? _c(
                          "section",
                          {
                            staticClass: "db relative center mw8 pt5 pt6-ns",
                            attrs: { id: _vm.page.act_section.id },
                          },
                          [
                            _vm.page.act_section.title
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "tl ttu f1 is-lorano-bold is-navy",
                                  },
                                  [_vm._v(_vm._s(_vm.page.act_section.title))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "mt4 pl0" },
                              _vm._l(
                                _vm.page.act_section.links,
                                function (item, index) {
                                  return _c(
                                    "li",
                                    { key: "act-link-" + index },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "db relative mv3 f3 f3-ns underline",
                                          attrs: {
                                            href: item.link,
                                            target: "_blank",
                                            title: item.title,
                                          },
                                        },
                                        [_vm._v(_vm._s(item.title))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.page.get_involved_section &&
                    _vm.page.get_involved_section.is_published
                      ? _c(
                          "section",
                          {
                            staticClass: "db relative center mw8 pt5 pt6-ns",
                            attrs: { id: _vm.page.get_involved_section.id },
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticClass: "tl ttu f1 is-lorano-bold is-navy",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.page.get_involved_section.title)
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.page.get_involved_section.justice_subtitle
                              ? _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt4 mt5-ns tl ttu f3 f2-ns is-lorano-bold is-navy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.get_involved_section
                                          .justice_subtitle
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row mt3 mh0" },
                              _vm._l(
                                _vm.page.get_involved_section.justice_orgs,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "org-item-" + index,
                                      staticClass:
                                        "col-xs-12 col-sm-6 mv3 ph0 pr4-ns",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer org-link",
                                          attrs: {
                                            href: item.link,
                                            title: item.title,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "mt4 tl ttu f3 is-tablet-bold is-navy",
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mt3 f4 lh-copy cms-content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("truncate")(
                                                item.text,
                                                160,
                                                "..."
                                              )
                                            ) + " "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "pointer b",
                                              attrs: { title: "Read More" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openModalComponent(
                                                    item.title,
                                                    item.text
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Read More")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "db mw5 mt3 btn-generic has-red-bg",
                                          attrs: {
                                            href: item.support,
                                            target: "_blank",
                                            title: "Support",
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(
                                              "\n                    Support\n                  "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _vm.page.get_involved_section.bay_area_subtitle
                              ? _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt5 tl ttu f3 f2-ns is-lorano-bold is-navy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.get_involved_section
                                          .bay_area_subtitle
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row mt3 mh0" },
                              _vm._l(
                                _vm.page.get_involved_section.bay_area_orgs,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "org-item-" + index,
                                      staticClass:
                                        "col-xs-12 col-sm-6 mv3 ph0 pr4-ns",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer org-link",
                                          attrs: {
                                            href: item.link,
                                            title: item.title,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "mt4 tl ttu f3 is-tablet-bold is-navy",
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mt3 f4 lh-copy cms-content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("truncate")(
                                                item.text,
                                                160,
                                                "..."
                                              )
                                            ) + " "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "pointer b",
                                              attrs: { title: "Read More" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openModalComponent(
                                                    item.title,
                                                    item.text
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Read More")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "db mw5 mt3 btn-generic has-red-bg",
                                          attrs: {
                                            href: item.support,
                                            target: "_blank",
                                            title: "Support",
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(
                                              "\n                    Support\n                  "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _vm.page.get_involved_section.national_subtitle
                              ? _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt5 tl ttu f3 f2-ns is-lorano-bold is-navy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.get_involved_section
                                          .national_subtitle
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row mt3 mh0" },
                              _vm._l(
                                _vm.page.get_involved_section.national_orgs,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "org-item-" + index,
                                      staticClass:
                                        "col-xs-12 col-sm-6 mv3 ph0 pr4-ns",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer org-link",
                                          attrs: {
                                            href: item.link,
                                            title: item.title,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "mt4 tl ttu f3 is-tablet-bold is-navy",
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mt3 f4 lh-copy cms-content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("truncate")(
                                                item.text,
                                                160,
                                                "..."
                                              )
                                            ) + " "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "pointer b",
                                              attrs: { title: "Read More" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openModalComponent(
                                                    item.title,
                                                    item.text
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Read More")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "db mw5 mt3 btn-generic has-red-bg",
                                          attrs: {
                                            href: item.support,
                                            target: "_blank",
                                            title: "Support",
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(
                                              "\n                    Support\n                  "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.page.follow_section &&
                    _vm.page.follow_section.is_published
                      ? _c(
                          "section",
                          {
                            staticClass: "db relative center mw8 pt5 pt6-ns",
                            attrs: { id: _vm.page.follow_section.id },
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticClass: "tl ttu f1 is-lorano-bold is-navy",
                              },
                              [_vm._v(_vm._s(_vm.page.follow_section.title))]
                            ),
                            _vm._v(" "),
                            _vm.page.follow_section.subtitle
                              ? _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt4 tl ttu f3 is-lorano-bold is-navy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.page.follow_section.subtitle)
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row mt3 mh0" },
                              _vm._l(
                                _vm.page.follow_section.orgs,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "org-item-" + index,
                                      staticClass:
                                        "col-xs-6 col-sm-4 col-md-3 col-lg-3 mv3 ph2 pr4-ns",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "db relative org-hdr-link grow",
                                          attrs: {
                                            href: item.link,
                                            title: item.title,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            directives: [
                                              {
                                                name: "lazy",
                                                rawName: "v-lazy",
                                                value: item.image,
                                                expression: "item.image",
                                              },
                                            ],
                                            staticClass:
                                              "db relative mt3 w-100 mw-100",
                                            attrs: { alt: item.title },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "mt4 tl ttu f3 is-tablet-bold is-navy",
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.page.support_section &&
                    _vm.page.support_section.is_published
                      ? _c(
                          "section",
                          {
                            staticClass: "db relative center mw8 pt5 pt6-ns",
                            attrs: { id: _vm.page.support_section.id },
                          },
                          [
                            _vm.page.support_section.title
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "tl ttu f1 is-lorano-bold is-navy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.page.support_section.title)
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "mt5 tl ttu f3 is-lorano-bold is-navy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.support_section
                                          .restaurants_subtitle
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "mt4 pl0" },
                                  _vm._l(
                                    _vm.page.support_section.restaurants,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        { key: "act-link-" + index },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "db relative mv3 f3 underline",
                                              attrs: {
                                                href: item.link,
                                                target: "_blank",
                                                title: item.title,
                                              },
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                                _vm.page.support_section.businesses_subtitle
                                  ? _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "mt5 tl ttu f3 is-lorano-bold is-navy",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.support_section
                                              .businesses_subtitle
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "mt4 pl0" },
                                  _vm._l(
                                    _vm.page.support_section.businesses,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        { key: "act-link-" + index },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "db relative mv3 f3 underline",
                                              attrs: {
                                                href: item.link,
                                                target: "_blank",
                                                title: item.title,
                                              },
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.page.end_text
                                ? _c("div", {
                                    staticClass: "mt4 f4 is-navy cms-content",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.marked(_vm.page.end_text)
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }